import React, { memo, SVGProps } from 'react'

export const Hamburger = memo((props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M19.2989 5.47871H4.70111C4.30367 5.47871 3.98111 5.80127 3.98111 6.19871C3.98111 6.59615 4.30367 6.91871 4.70111 6.91871H19.2979C19.6953 6.91871 20.0179 6.59615 20.0179 6.19871C20.0179 5.80127 19.6963 5.47871 19.2989 5.47871Z"
      fill="currentColor"
    />
    <path
      d="M19.2989 11.2387H4.70111C4.30367 11.2387 3.98111 11.5613 3.98111 11.9587C3.98111 12.3562 4.30367 12.6787 4.70111 12.6787H19.2979C19.6953 12.6787 20.0179 12.3562 20.0179 11.9587C20.0179 11.5613 19.6963 11.2387 19.2989 11.2387Z"
      fill="currentColor"
    />
    <path
      d="M19.2989 17.0813H4.70111C4.30367 17.0813 3.98111 17.4038 3.98111 17.8013C3.98111 18.1987 4.30367 18.5213 4.70111 18.5213H19.2979C19.6953 18.5213 20.0179 18.1987 20.0179 17.8013C20.0179 17.4038 19.6963 17.0813 19.2989 17.0813Z"
      fill="currentColor"
    />
  </svg>
))
